/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GenerateContentInput } from '../gql/graphql';
import { SAVE_GENERATED_CONTENT } from '../mutations/saveGeneratedContent';

export const useSaveGeneratedContent = () => {
  return useMutation<any, Error, GenerateContentInput>({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        { saveGeneratedContent: any },
        { input: GenerateContentInput }
      >(SAVE_GENERATED_CONTENT, { input });
      return data.saveGeneratedContent;
    },
  });
};
